(function($) {
	window.rw.theHeader = ()=> {
		const data = {currentScrollPosition: 0};

		window.rw.theHeader.scrollHandler = ()=> {
			if (window.innerWidth < 768) return;
			const scroll = window.pageYOffset;

			utils._slide(utils._getScrollDirection(scroll), scroll);
			data.currentScrollPosition = scroll;
		};

		const utils = {
			_getScrollDirection(position = 0) {
				return position >= data.currentScrollPosition ? 'down' : 'up';
			},
			_slide(direction = '', position) {
				const header = document.querySelector('[ref="the-header"]');
				const topPanel = header.querySelector('.page-header__top-panel');
				const main = header.querySelector('.page-header__main');
				const nav = header.querySelector('.page-header__nav');
				const mainMenuExpanded = header.querySelector('.main-menu__expanded');

				const top = (topPanel ? topPanel.offsetHeight : 0) + (main ? main.offsetHeight : 0);
				const isOnTop = position < top;

				if (direction === 'down' && !isOnTop) {
					mainMenuExpanded.style.height = `calc(100vh - ${nav.offsetHeight}px)`;
					header.style.transform = `translateY(-${top}px)`;
				}
				else if ((direction === 'up' && isOnTop) || (direction === 'down' && isOnTop)) {
					header.style.transform = `translateY(0px)`;
					mainMenuExpanded.style.height = `calc(100vh - ${top + nav.offsetHeight}px)`;
				}
			}

		};

		const render = () => {
			window.addEventListener('scroll', window.rw.theHeader.scrollHandler);
		};

		render();
		return {render};
	};

	document.addEventListener('DOMContentLoaded', ()=>{
		window.rw.theHeader();
	});
// eslint-disable-next-line no-undef
})(jQuery);
